import { PhoneNumber as PhoneNumberComponent } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import type { TextInputProps } from '@sravni/react-design-system/dist/types/components/TextInput';

import { useAppSelector } from 'shared/lib';

import { selectIsRestorePage } from 'entities/siteSettings';
import { isLoggedSelector } from 'entities/user';

export const PhoneNumber: FC<
  IFieldFactoryProps & { smsCodeFieldName: string; background?: TextInputProps['background'] }
> = (props) => {
  const { type, background } = props;
  const isAuth = useAppSelector(isLoggedSelector);
  const isRestorePage = useAppSelector(selectIsRestorePage);

  return (
    <PhoneNumberComponent
      {...props}
      type={type}
      background={background}
      isPhoneConfirmed={isAuth}
      isDisabled={isAuth || isRestorePage}
    />
  );
};
